import React, { FC, useRef, useState, useEffect } from 'react';
import CustomScroll from 'react-custom-scroll';
import Checkbox from '@mos-cat/checkbox';

import cn from 'classnames';
import arrow from '@assets/arrow-up.svg';
import { TRACK_OFFICE_SEARCH } from '@services/stats';
import OptionLabel from './private/OptionLabel';
import st from './ListFilter.module.css';

const plural = require('plural-ru');

type ListFilterProps = {
  filterType?: string;
  title?: string;
  filter: string;
  changeFilter: (arg: { fieldName: string; value: any }) => {};
  options?: [{ id: number; name: string; enabled: boolean }];
  selectedOptionsIds?: [number];
  placeholder?: string;
  renderAdditional?: (station: any) => any;
  handleSetTarget?: () => void;
  onChange: ({ any }) => {};
  dataTestId?: string;
};

const ListFilter: FC<ListFilterProps> = ({
  filterType = 'area',
  filter,
  changeFilter,
  title = '',
  placeholder = '',
  options = [],
  selectedOptionsIds = [],
  renderAdditional = () => null,
  onChange,
  handleSetTarget = () => null,
  dataTestId = 'areas',
}) => {
  const wrapperRef = useRef(null);
  const totalSelectedCount = selectedOptionsIds.length;

  const [isListOpen, setIsListOpen] = useState(false);

  const onCheckboxChange = (option) => {
    onChange({ fieldName: filterType, ...option, enabled: !option.enabled });
    if (filterType && !option.enabled)
      TRACK_OFFICE_SEARCH(filterType === 'areas', true);
  };

  const onInputChange = (e) => {
    changeFilter({ fieldName: filterType, value: e.target.value });
  };

  const onInputClick = () => {
    TRACK_OFFICE_SEARCH(filterType === 'areas', false);
  };

  const closeSearch = () => {
    setIsListOpen(false);
  };

  const displayInfo = () => {
    if (!totalSelectedCount) {
      return placeholder;
    }

    return filterType === 'areas'
      ? totalSelectedCount +
          plural(totalSelectedCount, ' район', ' района', ' районов')
      : totalSelectedCount +
          plural(totalSelectedCount, ' станция', ' станции', ' станций');
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const handleOutClick = (e) => {
      if (wrapperRef?.current?.contains(e.target)) {
        if (
          wrapperRef.current
            .querySelector('.listFilterDisplay')
            ?.contains(e.target)
        ) {
          setIsListOpen((prev) => !prev);
        } else {
          setIsListOpen(true);
        }
      } else {
        setIsListOpen(false);
      }
    };

    if (wrapperRef) {
      document.addEventListener('click', handleOutClick);
      return document.addEventListener('click', handleOutClick);
    }
  }, [wrapperRef]);

  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <div ref={wrapperRef} data-testid={dataTestId} className={st.main}>
      <div className={st.header}>
        <div className={st.title}>{title}</div>
      </div>
      <div className={cn(st.displayContainer, 'listFilterDisplay')}>
        <span data-testid="listFilterDisplay" className={st.display}>
          {displayInfo()}
        </span>
        <img
          src={arrow}
          alt="Toggle"
          className={isListOpen ? st.arrow : st.arrowDown}
        />
      </div>
      {isListOpen && (
        <div
          className={cn(st.optionsWrapper, {
            [st.optionsWrapperOpen]: isListOpen,
          })}
        >
          <div className={st.optionsHeader}>
            <p className={st.optionsTitle}>
              {filterType === 'areas' ? 'Районы' : 'Ближайшее метро'}
            </p>
            <button
              aria-label="closeSearch"
              type="button"
              className={st.close}
              onClick={closeSearch}
            />
          </div>
          <input
            className={st.search}
            value={filter}
            placeholder="Поиск по названию"
            onChange={onInputChange}
            onClick={onInputClick}
            data-testid="listFilterInput"
          />
          <CustomScroll heightRelativeToParent="100%">
            <div className={st.options}>
              {options.length ? (
                options.map((option) => (
                  <div
                    data-testid="listFilterOption"
                    key={option.id}
                    className={st.option}
                    onClick={handleSetTarget}
                  >
                    <Checkbox
                      indeterminate={null}
                      checked={option.enabled}
                      // prettier-ignore
                      label={(
                        <OptionLabel
                          option={option}
                          renderAdditional={renderAdditional}
                          filterType={filterType}
                        />
                        )}
                      value={option.id}
                      onChange={() => onCheckboxChange(option)}
                    />
                  </div>
                ))
              ) : (
                <p className={st.notFound}>Ничего не найдено</p>
              )}
            </div>
          </CustomScroll>
          <div className={st.footer}>
            <button
              type="button"
              data-testid="listFilterChoose"
              className={st.footerButton}
              onClick={closeSearch}
            >
              Применить
            </button>
          </div>
        </div>
      )}
    </div>
  );
  /* eslint-enable */
};

export default ListFilter;
